import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';
import type { EpicWithThunk } from 'state/state.common';

import { applyProductModificationEpic } from './applyProductModificationEpic';
import { createProductModificationTabEpic } from './createProductModificationTabEpic';
import { fetchProductModificationFormEpic } from './fetchProductModificationFormEpic';
import { fetchProductModificationFormWhenWorkspaceAlreadyInitializedEpic } from './fetchProductModificationFormWhenWorkspaceAlreadyInitializedEpic';
import { productModificationResultEpic } from './productModificationResultEpic';
import { fillProductModificationTabContentInPostTradeScreenEpic } from './tabContentEpic';

export function productModificationFormEpic(): EpicWithThunk {
  return withAppCrashIfException(
    'productModificationForm',
    combineEpics(
      createProductModificationTabEpic(),
      fetchProductModificationFormEpic(),
      fetchProductModificationFormWhenWorkspaceAlreadyInitializedEpic(),

      fillProductModificationTabContentInPostTradeScreenEpic(),
      applyProductModificationEpic(),
      productModificationResultEpic(),
    ),
  );
}
